import trainingActivities from './models/TrainingActivitiesHelper';
import TrainingActivitiesProofFiles from './models/TrainingActivitiesProofFiles';
import certificationLevels from './models/CertificationLevels';
import trainingMajors from './models/TrainingMajors';

export default {
  trainingActivities,
  TrainingActivitiesProofFiles,
  certificationLevels,
  trainingMajors,
};
